import { SvgIconProps } from "@mui/material";
export const ArrowLess = (props: SvgIconProps) => {
  return (
    <svg
      width="19"
      height="10"
      viewBox="0 0 19 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M17.4201 8.55001L10.9001 2.03001C10.1301 1.26001 8.87008 1.26001 8.10008 2.03001L1.58008 8.55001"
        stroke="#EB5027"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
